<template>
  <div>
    <el-dialog v-loading="loading" :title="title"
               :visible.sync="dialogTaskVisible" append-to-body
               @close="onClosed">
      <el-timeline v-if="activities.length > 0" :reverse="reverse">
        <el-timeline-item
            placement="top"
            v-for="(activity, index) in activities"
            :class="activity.type"
            :icon="activity.icon"
            :color="activity.color"
            :key="index"
            :timestamp="activity.timestamp">
          {{ activity.content }}
        </el-timeline-item>
      </el-timeline>
      <el-empty v-else :image-size="80" description="暂无消息"></el-empty>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "taskscenter",
  props: {
    title: {
      type: String,
      default: "我的消息",
    },
  },
  data() {
    return {
      loading: false,
      dialogTaskVisible: false,
      reverse: true,
      activities: [],
      currentFile : "",
    }
  },
  methods: {
    onClosed() {
      this.$emit('close');
    },
  },
  created() {
    this.$EventBus.$on("opendialogTaskCenter", (e) => {
      // if( this.activities?.length == 0 )
      //   this.$notify({ type: 'success', message: '暂无消息' });
      // else
        this.dialogTaskVisible = true;
    });

    this.$EventBus.$on( "runPbc", e => {
      let _rst      = JSON.parse( e );
      let _content  = "";
      let _success  = false;
      if( _rst.ruleId == "api000134" && _rst?.data?.data?.extends?.resource?.label ){
        this.currentFile  = _rst.data.data.extends.resource.label;
        _content  = `打开文件 《${this.currentFile}》`
        _success  = true;
      }else{
        _content  = `${_rst.actName}`;
        if( _rst?.data?.data?.code == 200 ){
          _success    = true;
          _content    += '处理完成';
        }else{
          _content    += '处理失败';
        }
      }

      this.activities.push({
        type      : _success ? "success" : "faild",
        content   : _content,
        timestamp : $func.getToday( false, true ),
        icon      : _success ? 'el-icon-circle-check' : "#el-icon-circle-close",
        color     : _success ? '#67C23A' : "#F56C6C",
      });

      if( !this.dialogTaskVisible ) {
        const h = this.$createElement;
        let _notify = this.$message({
          type: 'success',
          message: h( 'span', {
            on : {
              click : () => {
                this.$EventBus.$emit('opendialogTaskCenter');
                _notify.close();
              }
            }
          }, '收到新的消息，请在消息中心查看')
        });
        // let _notify = this.$notify({
        //   type: 'success', message: '收到新的消息，请在消息中心查看', onClick: () => {
        //     this.$EventBus.$emit('opendialogTaskCenter');
        //     _notify.close();
        //   }
        // });
      }
    } )
  }
}
</script>
<style scoped lang="less">
  .el-timeline{
    margin:10px;
    margin-top:20px;
    .el-timeline-item{
      /deep/.el-timeline-item__content{
        padding:3px 10px;
      }
      &.faild{
        /deep/.el-timeline-item__content{
          //color:#F56C6C;
        }
      }
      &.success{
        /deep/.el-timeline-item__content{
          //color:#67C23A;
        }
      }
    }
  }
</style>